import axios from 'axios'
import { API_BASE_URL, API_EXTERNAL_URL } from '../constants'


export const ping = ({ url = API_BASE_URL, timeout=5000, isOnlineCallback, isOfflineCallback }) => {
  return new Promise(resolve => {
    const isOnline = () => {
      isOnlineCallback()
      resolve(true);
    }
    const isOffline = () => {
      isOfflineCallback()
      resolve(false);
    }

    const xhr = new XMLHttpRequest();

    xhr.onerror = isOnline;
    xhr.ontimeout = isOffline;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === xhr.HEADERS_RECEIVED) {
        if (xhr.status) {
          isOnline();
        } else {
          isOffline();
        }
      }
    };

    xhr.open("GET", url);
    xhr.timeout = timeout;
    xhr.send();
  });
}


const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})


export const makeCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
  return client.request({
    method,
    data,
    url,
    headers,
    params,
    ...extra
  })
}


const externalClient = axios.create({
  baseURL: API_EXTERNAL_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})


export const makeExternalCall = (method, url, data = {}, headers = {}, params = {}, extra = {}) => {
  return externalClient.request({
    method,
    data,
    url,
    headers,
    params,
    ...extra
  })
}
